import { render, staticRenderFns } from "./business_template_management.vue?vue&type=template&id=08b31cc9&scoped=true"
import script from "./business_template_management.vue?vue&type=script&lang=js"
export * from "./business_template_management.vue?vue&type=script&lang=js"
import style0 from "./business_template_management.vue?vue&type=style&index=0&id=08b31cc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b31cc9",
  null
  
)

export default component.exports